export default {
  grupoFields: [
    {
      key: 'obra.nome',
      label: ' Obra',
      class: 'size-col-20',
    },
    {
      key: 'estoqueInsumo',
      label: ' Cod. | Insumo',
      class: 'size-col-20',
    },
    {
      key: 'qtde',
      label: 'Quantidade',
      class: 'size-col-20',
    },
    {
      key: 'insumo.unidade',
      label: 'Unid.',
      class: 'size-col-20',
    },
    {
      key: 'insumo.estoqueBaixo',
      label: 'Estoque mínimo',
      class: 'size-col-20',
    },
    {
      key: 'valor_unitario',
      label: 'Valor Unitário',
      class: 'size-col-20',
    },
    {
      key: 'valor_total',
      label: 'Valor Total',
      class: 'size-col-20',
    },
    {
      key: 'alertaEstoque',
      label: '',
      class: 'size-col-20',
    },
    {
      key: 'actions',
      label: '',
      class: 'size-col-20',
    },
  ],
  excelColumns: [
    {
      size: 70,
      label: 'Obra',
      field: 'obra',
    },
    {
      label: 'Código',
      field: 'codigo',
    },
    {
      label: 'Insumo',
      field: 'insumo',
    },
    {
      label: 'Observação',
      field: 'obs',
    },
    {
      label: 'Quantidade',
      field: 'qtde',
    },
    {
      label: 'Alerta',
      field: 'alerta',
    },
    {
      label: 'Unidade',
      field: 'unidade',
    },
    {
      label: 'Valor Unitário',
      field: 'valor_unitario',
    },
    {
      label: 'Valor Total',
      field: 'valor_total',
    },
  ],
  lowStockFields: [
    {
      key: 'obra.nome',
      label: ' Obra',
      class: 'size-col-20',
    },
    {
      key: 'estoqueInsumo',
      label: ' Cod. | Insumo',
      class: 'size-col-40',
    },
    {
      key: 'qtde',
      label: 'Em estoque',
      class: 'size-col-20',
    },
    {
      key: 'insumo.unidade',
      label: 'Unidade',
      class: 'size-col-20',
    },
    {
      key: 'insumo.estoqueBaixo',
      label: 'Estoque mínimo',
      class: 'size-col-20',
    },
    {
      key: 'editar',
      label: 'Editar',
      class: 'size-col-20',
    },
    {
      key: 'controlar',
      label: 'Est. Mín. Automático',
      class: 'size-col-20',
    },
  ],
  stockReportColumnsInExcel: [
    {
      label: 'Obra',
      field: 'obra',
    },
    {
      label: 'Código',
      field: 'codigo',
    },
    {
      label: 'Insumo',
      field: 'insumo',
    },
    {
      label: 'Qtde.',
      field: 'qtde',
    },
    {
      label: 'Unidade',
      field: 'unidade',
    },
    {
      label: 'Valor Unitário',
      field: 'valor_unitario',
      type: 'currency',
      dataFormat: (value) => {
        if (typeof value === 'string') {
          value = value.replace('R$', '')
          value = value.trim()
          value = value.replace(/\./g, '')
          value = value.replace(/,/g, '.')
          value = parseFloat(value)
          if (Number.isNaN(value)) {
            value = 0
          }
        }
        return value
      },
    },
    {
      label: 'Valor Total',
      field: 'valor_total',
      dataFormat: (value) => {
        if (typeof value === 'string') {
          value = value.replace('R$', '')
          value = value.trim()
          value = value.replace(/\./g, '')
          value = value.replace(/,/g, '.')
          value = parseFloat(value)
          if (Number.isNaN(value)) {
            value = 0
          }
        }
        return value
      },
    },
    {
      label: 'Alerta',
      field: 'alerta',
    },
  ],
}
